import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

import { containsOnlyNumbersOrEnglishLetters } from "../../../../_helpers/contains-only-numbers-or-english-letters";
import { FormControl, FormGroup } from "@angular/forms";
import { EventsService } from "../../../../_services/eventsServices/events.service";
import { RowEventEmit } from "../../../events-screen/event-page-models/row-event-emit";
import { SelectMenuOption } from "../../../../form/select-menu/select-menu.component";
import { ParentEventMessageType } from "../../../events-screen/event-page-models/parent-event-message";
import { SessionManagerService } from "../../../../_services/SessionManager/session-manager.service";

@Component({
  selector: "legacy-brother-attribution-main-search",
  templateUrl: "./legacy-brother-attribution-main-child-search.component.html",
  styleUrls: [
    "../../../events-screen/parent-events-page/event-page-search/event-page-search.component.scss",
    "./legacy-brother-attribution-main-child-search.component.scss",
  ],
  animations: [
    trigger("openClose", [
      state(
        "open",
        style({
          height: !EventsService.EventPageFeatures.showOnlyYearInAdvancedSearch
            ? "165px"
            : "100px",
          maxHeight: "230px",
          overflow: "visible",
          opacity: 1,
        })
      ),
      state(
        "closed",
        style({
          height: "1px",
          opacity: 0,
          overflow: "hidden",
        })
      ),
      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
  ],
})
export class LegacyBrotherAttributionMainChildSearchComponent {
  @ViewChild("componentMain") public componentMain: ElementRef;
  @ViewChild("multiselectInput") public multiselectInput: ElementRef;
  @Output("menu-event") public rowEvent: EventEmitter<RowEventEmit> =
    new EventEmitter<RowEventEmit>();
  public advanceSearchOpen: boolean = false;
  public advanceSearchForm = new FormGroup({
    limitToCurrentYear: new FormControl(false),
  });

  public dateTypeSelectMenuOptions: SelectMenuOption[] = [
    {
      icon: "",
      key: "eventDate",
      text: "תאריך אירוע",
      customValue: "",
    },
    {
      icon: "",
      key: "eventOpeningDate",
      text: "תאריך פתיחת הרשמה",
      customValue: "",
    },
    {
      icon: "",
      key: "eventClosingDate",
      text: "תאריך סגירת הרשמה",
      customValue: "",
    },
  ];
  public yearsSelectMenuOptions: SelectMenuOption[] = [
    {
      icon: "",
      key: "thisYear",
      text: 'תשפ"ד',
      customValue: "",
    },
    {
      icon: "",
      key: "allYears",
      text: "כל השנים",
      customValue: "",
    },
  ];
  public eventsTypeSelectMenuOptions: SelectMenuOption[] = [
    {
      icon: "",
      key: "allEventTypes",
      text: "כל הארועים",
      customValue: "",
    },
    {
      icon: "",
      key: "openAndCloseEvents",
      text: "ארועים פתוחים להרשמה",
      customValue: "",
    },
    {
      icon: "",
      key: "openAndCloseEvents",
      text: "ארועים סגורים להרשמה",
      customValue: "",
    },
  ];
  public DateTypeSelect: SelectMenuOption = this.dateTypeSelectMenuOptions[0];
  public EventTypeSelect: SelectMenuOption =
    this.eventsTypeSelectMenuOptions[0];
  public dateData: any;
  public dateData2: any;
  public yearsSelectedMenuOption: SelectMenuOption =
    this.yearsSelectMenuOptions[0];
  protected readonly parentEventQuestionsCardSelectMenuOptions = [];

  constructor(private eventsService: EventsService) {
    this.getCurrentYear().then();
  }

  public get advancedSearchFeatureActive(): boolean {
    return !EventsService.EventPageFeatures.showOnlyYearInAdvancedSearch;
  }

  public async getCurrentYear() {
    const shnatPeilut = await this.eventsService.getCurrentYear();
    if (shnatPeilut) {
      this.yearsSelectMenuOptions = this.yearsSelectMenuOptions.map((year) => {
        if (year.key === "thisYear") {
          return { ...year, text: shnatPeilut.value };
        }
        return year;
      });
    }
  }

  public getDataWithTerm(term: string) {
    return term;
  }

  public openMenu(openAdvancedSearch: MouseEvent) {}

  openAdvanced() {
    this.advanceSearchOpen = !this.advanceSearchOpen;
  }

  public search() {
    this.eventsService.parentEventMessage$.next({
      text: "החיפוש לא פעיל בדמו",
      type: ParentEventMessageType.Info,
    });
  }

  submitForm() {
    return false;
  }

  public setDateTypeSelect($event: SelectMenuOption) {}

  setEventTypeSelect($event: SelectMenuOption) {}

  public basicSearch() {
    const limitToCurrentYear = this.advanceSearchForm.value.limitToCurrentYear;
    const searchInputValue = this.multiselectInput.nativeElement.value || "";
    if (!searchInputValue.trim()) {
      return;
    }

    const searchParameters = containsOnlyNumbersOrEnglishLetters(
      searchInputValue.trim()
    )
      ? {
          code: searchInputValue.trim(),
          limitToCurrentYear,
        }
      : {
          name: searchInputValue.trim(),
          limitToCurrentYear,
        };
    this.eventsService.searchParentEvents(searchParameters).then();
  }

  public submitAdvancedSearch() {
    this.basicSearch();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/brothers-attribution/brothers-attribution-page/leagcy-brother-attribution-main-child-search/legacy-brother-attribution-main-child-search.component.ts